import { Component } from '@angular/core';

@Component({
  selector: 'app-counselling-landingpage',
  templateUrl: './counselling-landingpage.component.html',
  styleUrls: ['./counselling-landingpage.component.scss']
})
export class CounsellingLandingpageComponent {

}
